import { io } from "socket.io-client";

const TICKET_CHAT_NAMESPACE = "/ticket-chat";

const getSocketServerUrl = () => process.env.REACT_APP_SKALEBOT_SERVER || "";

export const createTicketChatSocket = (token) => {
  const baseUrl = getSocketServerUrl();
  return io(`${baseUrl}${TICKET_CHAT_NAMESPACE}`, {
    transports: ["websocket", "polling"],
    autoConnect: true,
    auth: {
      token,
      authorization: token,
    },
  });
};

export const joinTicketChatRoom = (socket, companyId, supportTicketId) => {
  if (!socket || !companyId || !supportTicketId) return;
  socket.emit("ticket:join", { companyId, supportTicketId });
};

export const leaveTicketChatRoom = (socket, companyId, supportTicketId) => {
  if (!socket || !companyId || !supportTicketId) return;
  socket.emit("ticket:leave", { companyId, supportTicketId });
};

export const sendTicketChatMessage = (
  socket,
  companyId,
  supportTicketId,
  message,
  messageType = "text"
) => {
  if (!socket || !companyId || !supportTicketId) return false;
  socket.emit("ticket:send", {
    companyId,
    supportTicketId,
    message,
    messageType,
  });
  return true;
};
